import { validateSchemaAsync } from '@/core/utils/safeSchemaValidations.ts'
import {
  ClientCreditDebt,
  clientCreditDebtSchema,
  promotionApiResponseScehma,
  promotionSchema
} from '../types/types.ts'
import gestionApiService from '@/core/services/gestionApiService.ts'

const getClientCreditDebit = (cedula: string) =>
  validateSchemaAsync(
    clientCreditDebtSchema,
    gestionApiService.httpGET<ClientCreditDebt>(
      `clients/${cedula}/credit-limit`
    )
  )

const getPromotionbyCedule = (
  cedula: string,
  brandId: string,
  modelId: string
) =>
  validateSchemaAsync(
    promotionSchema,
    gestionApiService.httpPOST<promotionApiResponseScehma>(
      `promotions/by-client/${cedula}`,
      {
        brandId: brandId,
        modelId: modelId
      }
    )
  )

const calculatorServices = {
  getClientCreditDebit,
  getPromotionbyCedule
}

export default calculatorServices
